<template>
    <Form>
      <section>
        <Modal
          v-model="modalTechnicalRequirement"
          :title="modalTechnicalRequirement_title"
          @on-ok="modalTechnicalRequirement_ok"
          @on-cancel="modalTechnicalRequirement_cancel" width="800"
          :mask-closable="false"
        >
          <slot name='body' style='text-align:center'>
            <Scroll>
            <Div align="justify" v-html="htmlTECHNICAL_REQUIREMENT">
            </Div>
            </Scroll>
          </slot>
        </Modal>
          <h3 class="title-bar clearfix">
              <span>{{$t('viewPdca.t1')}}</span>
          </h3>
          <div style="padding: 10px 20px;">
              <custom-panel name="1" :gutter="false">
                {{$t('viewPdca.t2')}}
                  <div slot="content">
                      <table class="form-table" cellspacing="0" cellpadding="0" border="0" width="100%">
                          <colgroup>
                              <col width="16.66%">
                              <col width="16.66%">
                              <col width="16.66%">
                              <col width="16.66%">
                              <col width="16.66%">
                              <col width="16.66%">
                          </colgroup>
                          <tbody>
                              <tr>
                                  <th align="right">
                                    {{$t('viewPdca.t3')}}
                                  </th>
                                  <td>
                                  <FormItem>
                                    <Input type="text" disabled v-model="mainFormData.form1Data.ID" :title="mainFormData.form1Data.ID"/>
                                  </FormItem>
                                  </td>
                                  <th align="right">
                                    {{$t('viewPdca.t4')}}
                                  </th>
                                  <td>
                                    <FormItem>
                                      <Input type="text" disabled v-model="mainFormData.form1Data.BARCODE_NUMBERS" :title="mainFormData.form1Data.BARCODE_NUMBERS"/>
                                    </FormItem>
                                  </td>
                                  <th align="right">
                                    {{$t('viewPdca.t5')}}
                                  </th>
                                  <td>
                                    <FormItem>
                                      <Input type="text" disabled v-model="mainFormData.form1Data.SUPPLIER_NAME" :title="mainFormData.form1Data.SUPPLIER_NAME"/>
                                    </FormItem>
                                  </td>
                              </tr>
                              <tr>
                                  <th align="right">
                                    {{$t('viewPdca.t6')}}
                                  </th>
                                  <td>
                                    <FormItem>
                                      <Input type="text" disabled v-model="mainFormData.form1Data.ITEM_CODE" :title="mainFormData.form1Data.ITEM_CODE"/>
                                    </FormItem>
                                  </td>
                                  <th align="right">
                                    {{$t('viewPdca.t7')}}
                                  </th>
                                  <td class="ellipsis">
                                    <FormItem>
                                      <Input type="text" disabled v-model="mainFormData.form1Data.ITEM_DESC" :title="mainFormData.form1Data.ITEM_DESC"/>
                                    </FormItem>
                                  </td>
                                <th align="right">{{$t('viewPdca.t8')}}</th>
                                <td>
                                  <FormItem>
                                    <Input type="text" disabled v-model="mainFormData.form1Data.BATCH_QTY"/>
                                  </FormItem>
                                </td>
                              </tr>
                              <tr>
                                <th align="right">{{$t('viewPdca.t9')}}</th>
                                <td>
                                  <FormItem>
                                    <Input type="text" disabled v-model="mainFormData.form1Data.STOCK_CODE"/>
                                  </FormItem>
                                </td>
                                <th align="right">{{$t('viewPdca.t10')}}</th>
                                <td>
                                  <FormItem>
                                    <Input type="text" disabled v-model="mainFormData.form1Data.ONETIME_PURCHASE_FLAG_TL"/>
                                  </FormItem>
                                </td>
                                <th align="right">{{$t('viewPdca.t11')}}</th>
                                <td>
                                  <FormItem>
                                    <Input type="text" disabled v-model="mainFormData.form1Data.EXAMINED_STRINGENCY_TL"/>
                                  </FormItem>
                                </td>
                              </tr>
                              <tr>
                                <th align="right">{{$t('viewPdca.t12')}}</th>
                                <td>
                                  <FormItem>
                                    <Input type="text" disabled v-model="mainFormData.form1Data.INSPECTION_LEVEL_TL"/>
                                  </FormItem>
                                </td>
                                <th align="right">{{$t('viewPdca.t13')}}</th>
                                <td>
                                  <FormItem>
                                    <Input type="text" disabled v-model="mainFormData.form1Data.EXAMINED_TYPE_TL"/>
                                  </FormItem>
                                </td>
                                <th align="right">{{$t('viewPdca.t14')}}</th>
                                <td>
                                  <FormItem>
                                    <Input type="text" disabled v-model="mainFormData.form1Data.TYPE_TEST_FLAG_TL"/>
                                  </FormItem>
                                </td>
                                <tr>
                                  <th align="right">{{$t('viewPdca.t15')}}</th>
                                  <td>
                                    <FormItem>
                                      <Input type="text" disabled v-model="mainFormData.form1Data.SORT_FLAG_TL"/>
                                    </FormItem>
                                  </td>
                                <th align="right">{{$t('viewPdca.t16')}}</th>
                                <td>
                                  <FormItem>
                                    <Input type="text" disabled v-model="mainFormData.form1Data.HS_FLAG_TL"/>
                                  </FormItem>
                                </td>
                                  <th align="right">{{$t('viewPdca.t17')}}</th>
                                  <td>
                                    <FormItem>
                                      <Input type="text" disabled v-model="mainFormData.form1Data.TRIAL_FLAG_TL"/>
                                    </FormItem>
                                  </td>
                              </tr>
                              <tr>
                                  <th align="right">{{$t('viewPdca.t18')}}</th>
                                  <td>
                                    <FormItem>
                                      <Input type="text" disabled v-model="mainFormData.form1Data.COMMON_STANDARDS_NAME"/>
                                    </FormItem>
                                  </td>
                                  <th align="right">{{$t('viewPdca.t19')}}</th>
                                  <td>
                                    <FormItem>
                                      <Input type="text" disabled v-model="mainFormData.form1Data.SPECIAL_STANDARDS_NAME"/>
                                    </FormItem>
                                  </td>
                                <th align="right">{{$t('viewPdca.t20')}}</th>
                                <td>
                                  <FormItem>
                                    <Input type="text" disabled v-model="mainFormData.form1Data.SAMPLE_QTY"/>
                                  </FormItem>
                                </td>
                              </tr>
                              <tr>
                                  <th align="right">{{$t('viewPdca.t21')}}</th>
                                  <td>
                                    <FormItem>
                                      <Input type="text" disabled v-model="mainFormData.form1Data.BRAND"/>
                                    </FormItem>
                                  </td>
                                <th align="right">{{$t('viewPdca.t22')}}</th>
                                <td>
                                  <FormItem>
                                    <Input type="text" disabled v-model="mainFormData.form1Data.BATCH_INFO"/>
                                  </FormItem>
                                </td>
                                <th align="right">{{$t('viewPdca.t23')}}</th>
                                <td>
                                  <FormItem>
                                    <Input type="text" disabled v-model="mainFormData.form1Data.DEFECT_CLASS_TL"/>
                                  </FormItem>
                                </td>
                              </tr>
                              <tr>
                                <th align="right">{{$t('viewPdca.t24')}}</th>
                                <td>
                                  <FormItem>
                                    <Input type="text" disabled v-model="mainFormData.form1Data.LIABILITY_ATTRIBUTION_TL"/>
                                  </FormItem>
                                </td>
                                <th align="right">{{$t('viewPdca.t25')}}</th>
                                <td>
                                  <FormItem>
                                    <Input type="text" disabled v-model="mainFormData.form1Data.RESPONSIBILITY_INSIDE_TL"/>
                                  </FormItem>
                                </td>
                                <th align="right">{{$t('viewPdca.t26')}}</th>
                                <td>
                                  <FormItem>
                                    <Input type="text" disabled v-model="mainFormData.form1Data.CHECKED_RESULT_TL"/>
                                  </FormItem>
                                </td>
                              </tr>
                              <tr>
                                <th align="right">{{$t('viewPdca.t27')}}</th>
                                <td colspan="5" align="left">
                                  <FormItem>
                                    <Input type="textarea" rows="3" disabled v-model="mainFormData.form1Data.REMARK"/>
                                  </FormItem>
                                </td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </custom-panel>
              <custom-panel name="1" style="margin-top: 20px;">
                {{$t('viewPdca.t28')}}
                  <div slot="content">
                    <ul v-if="this.mainFormData.form2Data.downloadList.length > 0" class="upload-list">
                      <li
                        v-for="file in downloadList"
                        class="upload-list-file upload-list-file-finish">
                        <a @click.prevent="downloadUploadListFile(file.fileId)">
                          <Icon :type="format(file)"></Icon> <span>{{file.name}}</span>
                        </a>
                      </li>
                    </ul>
                    </div>
              </custom-panel>
              <custom-panel name="1" style="margin-top: 20px;" :gutter="false">
                {{$t('viewPdca.t29')}}
                  <div slot="content">
                      <div class="ivu-table-wrapper">
                          <div class="ivu-table ivu-table-stripe ivu-table-border ivu-table-with-fixed-top">
                              <div class="ivu-table-header" ref="header" @mousewheel="handleMouseWheel">
                                  <table cellspacing="0" cellpadding="0" border="0" width="100%">
                                      <colgroup>
                                          <col width="150">
                                          <col width="150">
                                          <col width="150">
                                          <col width="150">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="80" v-for="i in SAMPLE_METERING_COUNT_LIST">
                                          <col width="100">
                                          <col width="100">
                                          <col width="150">
                                          <col width="10">
                                      </colgroup>
                                      <thead>
                                          <tr>
                                              <th>
                                                  <div class="ivu-table-cell">
                                                      <span>{{$t('viewPdca.t30')}}</span>
                                                  </div>
                                              </th>
                                              <th>
                                                  <div class="ivu-table-cell">
                                                      <span>{{$t('viewPdca.t31')}}</span>
                                                  </div>
                                              </th>
                                            <th>
                                              <div class="ivu-table-cell">
                                                <span>{{$t('viewPdca.t32')}}</span>
                                              </div>
                                            </th>
                                              <th>
                                                  <div class="ivu-table-cell">
                                                      <span>{{$t('viewPdca.t33')}}</span>
                                                  </div>
                                              </th>
                                              <th>
                                                  <div class="ivu-table-cell">
                                                      <span>{{$t('viewPdca.t34')}}</span>
                                                  </div>
                                              </th>
                                              <th>
                                                  <div class="ivu-table-cell">
                                                      <span>{{$t('viewPdca.t35')}}</span>
                                                  </div>
                                              </th>
                                              <th>
                                                  <div class="ivu-table-cell">
                                                      <span>{{$t('viewPdca.t36')}}</span>
                                                  </div>
                                              </th>
                                              <th>
                                                  <div class="ivu-table-cell">
                                                      <span>{{$t('viewPdca.t37')}}</span>
                                                  </div>
                                              </th>
                                              <th>
                                                  <div class="ivu-table-cell">
                                                      <span>{{$t('viewPdca.t38')}}</span>
                                                  </div>
                                              </th>
                                              <th>
                                                <div class="ivu-table-cell">
                                                  <span>{{$t('viewPdca.t39')}}</span>
                                                </div>
                                              </th>
                                              <th>
                                                  <div class="ivu-table-cell">
                                                      <span>{{$t('viewPdca.t40')}}</span>
                                                  </div>
                                              </th>
                                            <th>
                                              <div class="ivu-table-cell">
                                                <span>{{$t('viewPdca.t41')}}</span>
                                              </div>
                                            </th>
                                              <th>
                                                  <div class="ivu-table-cell">
                                                      <span>{{$t('viewPdca.t42')}}</span>
                                                  </div>
                                              </th>
                                            <th>
                                              <div class="ivu-table-cell">
                                                <span>{{$t('viewPdca.t43')}}</span>
                                              </div>
                                            </th>
                                            <th v-for="i in SAMPLE_METERING_COUNT_LIST">
                                              <div class="ivu-table-cell">
                                                <span>{{$t('viewPdca.t44')}}{{ i + 1}}</span>
                                              </div>
                                            </th>
                                              <th>
                                                  <div class="ivu-table-cell">
                                                      <span>{{$t('viewPdca.t45')}}</span>
                                                  </div>
                                              </th>
                                            <th>
                                              <div class="ivu-table-cell">
                                                <span>{{$t('viewPdca.t46')}}</span>
                                              </div>
                                            </th>
                                            <th>
                                              <div class="ivu-table-cell">
                                                <span>{{$t('viewPdca.t47')}}</span>
                                              </div>
                                            </th>
                                          </tr>
                                      </thead>
                                  </table>
                              </div>
                              <div class="ivu-table-body ivu-table-overflowY ivu-table-overflowX" ref="body" @scroll="handleBodyScroll">
                                  <table cellspacing="0" cellpadding="0" ref="tbody" border="0" style="width: 100%;">
                                      <colgroup>
                                          <col width="150">
                                          <col width="150">
                                          <col width="150">
                                          <col width="150">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="80" v-for="i in SAMPLE_METERING_COUNT_LIST">
                                          <col width="100">
                                          <col width="100">
                                          <col width="150">
                                      </colgroup>
                                      <tbody class="ivu-table-tbody">
                                          <tr class="ivu-table-row" v-for="item in mainFormData.form3Data" @click="form3TableRowClick(item.index)">
                                              <td class="">
                                                  <div class="ivu-table-cell">
                                                      <span>{{ item.ITEMS_CATEGORY_TL }}</span>
                                                  </div>
                                              </td>
                                              <td class="">
                                                  <div class="ivu-table-cell">
                                                      <span>{{ item.ITEMS_NAME }}</span>
                                                  </div>
                                              </td>
                                            <td class="">
                                              <div class="ivu-table-cell">
                                                <Button style="width: 80px;" icon="eye" type="info" shape="circle" @click="showTECHNICAL_REQUIREMENT(item.TECHNICAL_REQUIREMENT)"></Button>
                                              </div>
                                            </td>
                                              <td class="">
                                                  <div class="ivu-table-cell">
                                                      <span>≥{{ item.ITEMS_PROPERTY_FLOOR }}</span>
                                                  </div>
                                              </td>
                                              <td class="">
                                                  <div class="ivu-table-cell">
                                                      <span>≤{{ item.ITEMS_PROPERTY_CEILING }}</span>
                                                  </div>
                                              </td>
                                              <td class="">
                                                  <div class="ivu-table-cell">
                                                      <span>{{ item.ITEMS_PROPERTY_BENCHMARK }}</span>
                                                  </div>
                                              </td>
                                              <td class="">
                                                  <div class="ivu-table-cell">
                                                      <span>{{ item.ITEMS_PROPERTY_UOM }}</span>
                                                  </div>
                                              </td>
                                              <td class="">
                                                  <div class="ivu-table-cell">
                                                      <span>{{ item.ITEMS_LEVEL }}</span>
                                                  </div>
                                              </td>
                                              <td class="">
                                                  <div class="ivu-table-cell">
                                                      <span>{{ item.EXAMINED_TOOL }}</span>
                                                  </div>
                                              </td>
                                              <td class="">
                                                <div class="ivu-table-cell">
                                                  <span>{{ item.EXAMINED_BASIS }}</span>
                                                </div>
                                              </td>
                                              <td class="">
                                                  <div class="ivu-table-cell">
                                                      <span>{{ item.INSPECTION_LEVEL_TL }}</span>
                                                  </div>
                                              </td>
                                            <td class="">
                                              <div class="ivu-table-cell">
                                                <span>{{ item.NG_LEVEL }}</span>
                                              </div>
                                            </td>
                                              <td class="">
                                                  <div class="ivu-table-cell">
                                                      <span>{{ item.SAMPLE_QTY }}</span>
                                                  </div>
                                              </td>
                                            <td class="">
                                              <div class="ivu-table-cell">
                                                <span>{{ item.CHECKED_RESULT }}</span>
                                              </div>
                                            </td>
                                            <td class="" v-for="i in SAMPLE_METERING_COUNT_LIST">
                                              <div class="ivu-table-cell">
                                                <span>{{ item.SAMPLE_METERING_COUNT_OBJ[i].SAMPLE_METERING }}</span>
                                              </div>
                                            </td>
                                              <td class="">
                                                  <div class="ivu-table-cell">
                                                      <span>{{ item.NG_QTY }}</span>
                                                  </div>
                                              </td>
                                            <td class="">
                                              <div class="ivu-table-cell">
                                                <span>{{ item.NG_INFO }}</span>
                                              </div>
                                            </td>
                                            <td class="">
                                              <div class="ivu-table-cell">
                                                <span>{{ item.REMARK }}</span>
                                              </div>
                                            </td>
                                          </tr>
                                          </tr>
                                      </tbody>
                                  </table>
                              </div>
                          </div>
                      </div>
                  </div>
              </custom-panel>
              <custom-panel name="1" style="margin-top: 20px;" :gutter="false">
                {{$t('viewPdca.t48')}}
                  <div slot="content">
                      <div class="ivu-table-wrapper">
                          <div class="ivu-table ivu-table-stripe ivu-table-border ivu-table-with-fixed-top">
                              <div class="ivu-table-header" ref="header2" @mousewheel="handleMouseWheel2">
                                  <table cellspacing="0" cellpadding="0" border="0" width="100%">
                                      <colgroup>
                                          <col width="150">
                                          <col width="150">
                                          <col width="150">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="80">
                                          <col width="100">
                                          <col width="150">
                                          <col width="10">
                                      </colgroup>
                                      <thead>
                                          <tr>
                                              <th>
                                                  <div class="ivu-table-cell">
                                                      <span>{{$t('viewPdca.t30')}}</span>
                                                  </div>
                                              </th>
                                              <th>
                                                  <div class="ivu-table-cell">
                                                      <span>{{$t('viewPdca.t31')}}</span>
                                                  </div>
                                              </th>
                                              <th>
                                                  <div class="ivu-table-cell">
                                                      <span>{{$t('viewPdca.t32')}}</span>
                                                  </div>
                                              </th>
                                              <th>
                                                  <div class="ivu-table-cell">
                                                      <span>{{$t('viewPdca.t37')}}</span>
                                                  </div>
                                              </th>
                                              <th>
                                                  <div class="ivu-table-cell">
                                                      <span>{{$t('viewPdca.t38')}}</span>
                                                  </div>
                                              </th>
                                              <th>
                                                <div class="ivu-table-cell">
                                                  <span>{{$t('viewPdca.t39')}}</span>
                                                </div>
                                              </th>
                                              <th>
                                                  <div class="ivu-table-cell">
                                                      <span>{{$t('viewPdca.t2')}}</span>
                                                  </div>
                                              </th>
                                              <th>
                                                  <div class="ivu-table-cell">
                                                      <span>{{$t('viewPdca.t42')}}</span>
                                                  </div>
                                              </th>
                                            <th>
                                              <div class="ivu-table-cell">
                                                <span>{{$t('viewPdca.t43')}}</span>
                                              </div>
                                            </th>
                                              <th>
                                                  <div class="ivu-table-cell">
                                                      <span>{{$t('viewPdca.t45')}}</span>
                                                  </div>
                                              </th>
                                              <th>
                                                  <div class="ivu-table-cell">
                                                      <span>{{$t('viewPdca.t46')}}</span>
                                                  </div>
                                              </th>
                                              <th>
                                                  <div class="ivu-table-cell">
                                                      <span>{{$t('viewPdca.t47')}}</span>
                                                  </div>
                                              </th>
                                          </tr>
                                      </thead>
                                  </table>
                              </div>
                              <div class="ivu-table-body ivu-table-overflowY ivu-table-overflowX" ref="body2" @scroll="handleBodyScroll2">
                                  <table cellspacing="0" cellpadding="0" ref="tbody" border="0" style="width: 100%;">
                                      <colgroup>
                                          <col width="150">
                                          <col width="150">
                                          <col width="150">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="100">
                                          <col width="80">
                                          <col width="100">
                                          <col width="150">
                                      </colgroup>
                                      <tbody class="ivu-table-tbody">
                                          <tr class="ivu-table-row" v-for="item in this.mainFormData.form4Data" @click="form4TableRowClick(item.index)">
                                              <td class="">
                                                  <div class="ivu-table-cell">
                                                      <span>{{ item.ITEMS_CATEGORY_TL }}</span>
                                                  </div>
                                              </td>
                                              <td class="">
                                                  <div class="ivu-table-cell">
                                                      <span>{{ item.ITEMS_NAME }}</span>
                                                  </div>
                                              </td>
                                            <td class="">
                                              <div class="ivu-table-cell">
                                                <Button style="width: 80px;" icon="eye" type="info" shape="circle" @click="showTECHNICAL_REQUIREMENT(item.TECHNICAL_REQUIREMENT)"></Button>
                                              </div>
                                            </td>
                                              <td class="">
                                                  <div class="ivu-table-cell">
                                                      <span>{{ item.ITEMS_LEVEL }}</span>
                                                  </div>
                                              </td>
                                              <td class="">
                                                  <div class="ivu-table-cell">
                                                      <span>{{ item.EXAMINED_TOOL }}</span>
                                                  </div>
                                              </td>
                                            <td class="">
                                              <div class="ivu-table-cell">
                                                <span>{{ item.EXAMINED_BASIS }}</span>
                                              </div>
                                            </td>
                                              <td class="">
                                                  <div class="ivu-table-cell">
                                                      <span>{{ item.INSPECTION_LEVEL_TL }}</span>
                                                  </div>
                                              </td>
                                              <td class="">
                                                  <div class="ivu-table-cell">
                                                      <span>{{ item.SAMPLE_QTY }}</span>
                                                  </div>
                                              </td>
                                            <td class="">
                                              <div class="ivu-table-cell">
                                                <span>{{ item.CHECKED_RESULT }}</span>
                                              </div>
                                            </td>
                                              <td class="">
                                                  <div class="ivu-table-cell">
                                                    <FormItem>
                                                      <span>{{ item.NG_QTY }}</span>
                                                    </FormItem>
                                                  </div>
                                              </td>
                                              <td class="">
                                                  <div class="ivu-table-cell">
                                                    <FormItem>
                                                      <span>{{ item.NG_INFO }}</span>
                                                    </FormItem>
                                                  </div>
                                              </td>
                                              <td class="">
                                                  <div class="ivu-table-cell">
                                                    <FormItem>
                                                      <span>{{ item.REMARK }}</span>
                                                    </FormItem>
                                                  </div>
                                              </td>
                                          </tr>
                                          </tr>
                                      </tbody>
                                  </table>
                              </div>
                          </div>
                      </div>
                  </div>
              </custom-panel>
              <custom-panel name="1" style="margin-top: 20px;">
                {{$t('viewPdca.t49')}}
                  <div slot="content">
                      <ul v-if="this.mainFormData.form5Data.downloadList.length > 0" class="upload-list">
                          <li
                              v-for="file in this.mainFormData.form5Data.downloadList"
                              class="upload-list-file upload-list-file-finish">
                              <a @click.prevent="downloadUploadListFile(file.fileId)">
                                  <Icon :type="format(file)"></Icon> <span>{{file.name}}</span>
                              </a>
                          </li>
                      </ul>
                  </div>
              </custom-panel>
          </div>
      </section>
    </Form>
  </template>
  <style lang="less" scoped>
    .m-form-item {
      margin-bottom: 0px;
      vertical-align: top;
      zoom: 1;
    }
      .upload-list{
          margin-top: 8px;
  
          &-file{
              padding: 10px 4px;
              width: 250px;
              color: #333;
              border-radius: 2px;
              overflow: hidden;
              position: relative;
              background: #fff;
              margin-bottom: 10px;
              box-shadow: 0 1px 6px rgba(0,0,0,.2);
              &:last-child {
                  margin-bottom: 0;
              }
              & > span{
                  cursor: pointer;
                  display: inline-block;
                  height: 24px;
                  vertical-align: middle;
                  span {
                      line-height: 24px;
                      height: 24px;
                      display: inline-block;
                  }
                  i{
                      float: left;
                      display: inline-block;
                      font-size: 24px;
                      width: 24px;
                      height: 24px;
                      color: #333;
                      text-align: center;
                      margin-right: 5px;
                  }
              }
              &:hover{
                  background: #ccc;
                  & > span{
                      color: #007AFF;
                      i{
                          color: #999;
                      }
                  }
                  .upload-list-remove{
                      opacity: 1;
                  }
              }
          }
          &-remove{
              opacity: 0;
              font-size: 18px;
              cursor: pointer;
              float: right;
              margin-right: 4px;
              color: #333;
              &:hover{
                  color: #444;
              }
          }
      }
      .title-bar {
          background-color: #F2F2F2;
          border: 1px solid #dddee1;
          padding: 10px 20px;
          button {
              float: right;
          }
          span {
              border-left: 5px solid #3AA2EB;
              padding: 0 7px;
              font-size: 15px;
              font-weight: 400;
              height: 32px;
              line-height: 32px;
          }
      }
  
      .form-table {
          width: 100%;
          table-layout: fixed;
          background: #FFF;
          th {
              background-color: #FFF;
          }
          th,
          td {
              height: 40px;
              line-height: 40px;
              border-bottom: 1px solid #e9eaec;
              border-right: 1px solid #e9eaec;
              padding: 0 5px;
          }
          td {
              text-align: center;
              background-color: #fff;
          }
          .ellipsis {
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
              box-sizing: border-box;
              word-break: keep-all;
              white-space: nowrap;
              overflow: hidden;
          }
      }
  
      @css-prefix: ivu-;
      @table-prefix-cls: ~"@{css-prefix}table";
      @table-select-item-prefix-cls: ~"@{table-prefix-cls}-filter-select-item";
      @border-color-base: #dddee1;
      @text-color: #495060;
      @font-size-base: 14px;
      @font-size-small: 12px;
      @border-color-split: #e9eaec;
      @head-bg: #f9fafc;
      @table-thead-bg: #f8f8f9;
      @table-td-stripe-bg: #f8f8f9;
      @table-td-hover-bg: #ebf7ff;
      @table-td-highlight-bg: #ebf7ff;
      @animation-time: .3s;
      @transition-time: .2s;
      @ease-in-out: ease-in-out;
      @shadow-color: rgba(0, 0, 0, .2);
      @shadow-base: @shadow-down;
      @shadow-card: 0 1px 1px 0 rgba(0, 0, 0, .1);
      @shadow-up: 0 -1px 6px @shadow-color;
      @shadow-down: 0 1px 6px @shadow-color;
      @shadow-left: -1px 0 6px @shadow-color;
      @shadow-right: 1px 0 6px @shadow-color;
      .layout {
          padding: 10px;
      }
  
      .wrapper {
          background: #FFF;
      }
  
      .@{table-prefix-cls} {
          &-wrapper {
              position: relative;
              border: 1px solid @border-color-base;
              border-bottom: 0;
              border-right: 0;
          }
          width: inherit;
          height: 100%;
          max-width: 100%;
          overflow: hidden;
          color: @text-color;
          font-size: @font-size-small;
          background-color: #fff;
          box-sizing: border-box;
          &-hide {
              opacity: 0;
          }
          &:before {
              content: '';
              width: 100%;
              height: 1px;
              position: absolute;
              left: 0;
              bottom: 0;
              background-color: @border-color-base;
              z-index: 1;
          }
          &:after {
              content: '';
              width: 1px;
              height: 100%;
              position: absolute;
              top: 0;
              right: 0;
              background-color: @border-color-base;
              z-index: 3;
          }
          &-header {
              overflow: hidden;
          }
          &-body {
              overflow: auto;
          }
          th,
          td {
              min-width: 0;
              height: 48px;
              box-sizing: border-box;
              text-align: left;
              text-overflow: ellipsis;
              vertical-align: middle;
              border-bottom: 1px solid @border-color-split;
          }
          th {
              height: 40px;
              white-space: nowrap;
              overflow: hidden;
              background-color: @table-thead-bg;
              &.table-info-cell-name {
                  background-color: #FFFF99;
              }
          }
          td {
              background-color: #fff;
              transition: background-color @transition-time @ease-in-out;
          }
          th&-column,
          td&-column {
              &-left {
                  text-align: left;
              }
              &-center {
                  text-align: center;
              }
              &-right {
                  text-align: right;
              }
          }
          table {
              table-layout: fixed;
          }
          &-border {
              th,
              td {
                  border-right: 1px solid @border-color-split;
              }
          }
          .ellipsis {
             overflow: hidden;
             text-overflow: ellipsis;
             word-break: break-all;
             box-sizing: border-box;
             word-break: keep-all;
             white-space: nowrap;
             overflow: hidden;
           }
          &-cell {
              padding-left: 10px;
             padding-right: 10px;
             overflow: hidden;
             text-overflow: ellipsis;
             white-space: normal;
             word-break: break-all;
             box-sizing: border-box;
              &-ellipsis {
                  word-break: keep-all;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
              }
              &-with-expand {
                  height: 47px;
                  line-height: 47px;
                  padding: 0;
                  text-align: center;
              }
              &-expand {
                  cursor: pointer;
                  transition: transform @transition-time @ease-in-out;
                  i {
                      font-size: @font-size-base;
                  }
                  &-expanded {
                      transform: rotate(90deg);
                  }
              }
          }
          &-hidden {
              visibility: hidden;
          }
          th &-cell {
              display: inline-block;
              word-wrap: normal;
              vertical-align: middle;
          }
          td&-expanded-cell {
              padding: 20px 50px;
              background: @table-thead-bg;
          }
          tr&-row-hover {
              td {
                  background-color: @table-td-hover-bg;
              }
          }
          &-stripe &-body,
          &-stripe &-fixed-body {
              tbody:nth-child(2n+1) {
                  td {
                      background-color: @table-td-stripe-bg;
                  }
              }
          }
          .ivu-table-overflowX {
              overflow-x: scroll;
          }
          .ivu-table-overflowY {
              overflow-y: scroll;
          }
      }
  </style>
  <script>
    import CustomPanel from '@/components/awesome/page/panel/index';
    import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
    import axios from 'axios';
    export default {
      name: 'viewShipmentInspection',
      components: {
        CustomPanel,
        mAssemblyTable
      },
      data() {
        return {
          param: {
            id: this.$route.query.sourceId, // 检验单ID
            language: this.$route.query.language // 语言 ZH_CN
          },
          vendorId: null,
          vendorCode: null,
          vendorName: null,
          userName: null,
          barcodeNumbers: null, // 条码号（多个时用逗用分开）
          mainFormData: {
            form1Data: {
              ID: '',
              BARCODE_NUMBERS: '',
              ORG_ID: '',
              ORG_NAME: '',
              SUPPLIER_ID: '',
              SUPPLIER_CODE: '',
              SUPPLIER_NAME: '',
              ITEM_ID: '',
              ITEM_CODE: '',
              ITEM_DESC: '',
              BATCH_QTY: '',
              STOCK_CODE: '',
              ONETIME_PURCHASE_FLAG_TL: '',
              EXAMINED_STRINGENCY_TL: '',
              EXAMINED_TYPE_TL: '',
              TYPE_TEST_FLAG_TL: '',
              SORT_FLAG_TL: '',
              HS_FLAG_TL: '',
              INSPECTION_LEVEL: '',
              INSPECTION_LEVEL_TL: '',
              EXAMINED_STRINGENCY: '',
              ONETIME_PURCHASE_FLAG: '',
              TRIAL_FLAG: '',
              TRIAL_FLAG_TL: '',
              SAMPLE_QTY: '',
              COMMON_STANDARDS_ID: '',
              COMMON_STANDARDS_NAME: '',
              SPECIAL_STANDARDS_ID: '',
              SPECIAL_STANDARDS_NAME: '',
              CHECKED_RESULT: '',
              CHECKER: '',
              BRAND: '',
              BATCH_INFO: '',
              DEFECT_CLASS_TL: '',
              LIABILITY_ATTRIBUTION_TL: '',
              RESPONSIBILITY_INSIDE_TL: '',
              CHECKED_RESULT_TL: '',
              REMARK: ''
            },
            form2Data: {
              downloadList: []
            },
            form3Data: [],
            form4Data: [],
            form5Data: {
              downloadList: []
            },
            backDataJson: null
          },
          SAMPLE_METERING_COUNT_LIST: [],
          htmlTECHNICAL_REQUIREMENT: '',
          modalTechnicalRequirement: false,
          modalTechnicalRequirement_title: '技术要求',
          downloadUploadListFileUrl: '/qms2gsc/file/download?id=',
          uploadFileUrl: '/qms2gsc/file/upload?',
          busid: '',
          appendFile: null,
          appendFileLoadingStatus: false,
          condition: null
        };
      },
      mounted() {
        this.getVendorId();
      },
      watch: {
        '$route' (to, from) {
          this.reload();
        }
      },
      methods: {
        getVendorId() {
          axios.get('/gscint/vendor/getCurrentVendor', {
            params: {}
          }).then(res => {
            this.vendorId = res.data.data.vendorId;
            this.vendorCode = res.data.data.vendorCode;
            this.vendorName = res.data.data.vendorName;
            this.userName = res.data.data.userName;
            if (this.vendorId === '' || this.vendorId === undefined) {
              this.$Message.error(this.$t('common.reload'));
              return;
            }
  
            this.iqcOutgoingQryReport(this.param.id, this.param.language);
          });
        },
        reload() {
          this.param.id = this.$route.query.sourceId;
          this.param.language = this.$route.query.language;
          this.$route.query.sourceId = '';
          this.$route.query.language = '';
          if (!this.isEmptyValue(this.param.id)) {
            window.sessionStorage.setItem('viewShipmentInspection_param_id', this.param.id);
          }
          this.param.id = window.sessionStorage.getItem('viewShipmentInspection_param_id');
          if (!this.isEmptyValue(this.param.language)) {
            window.sessionStorage.setItem('viewShipmentInspection_param_language', this.param.language);
          }
          this.param.language = window.sessionStorage.getItem('viewShipmentInspection_param_language');
          /* mounted - start */
          this.getVendorId();
          /* mounted - end */
        },
        iqcOutgoingQryReport(id, language) {
          axios.get('/qms2gsc/IqcOutgoing/ViewIncomingReport', {
            params: {
              id,
              language
            }
          }).then(res => {
            let jsonStr = res.data.substring(1).substring(0, res.data.length - 3);
            let result = JSON.parse(jsonStr);
            if (result.IsSucess === true) {
              this.mainFormData.backDataJson = result;
              let MainResultData = result.MainResultData;
              this.mainFormData.form1Data.ID = MainResultData.EXAMINED_NO;
              this.mainFormData.form1Data.BARCODE_NUMBERS = MainResultData.BARCODE_NUMBERS;
              this.mainFormData.form1Data.ORG_ID = MainResultData.ORG_ID;
              this.mainFormData.form1Data.ORG_NAME = MainResultData.ORG_DESC;
              this.mainFormData.form1Data.SUPPLIER_ID = MainResultData.SUPPLIER_ID;
              this.mainFormData.form1Data.SUPPLIER_CODE = MainResultData.SUPPLIER_CODE;
              this.mainFormData.form1Data.SUPPLIER_NAME = MainResultData.SUPPLIER_DESC;
              this.mainFormData.form1Data.ITEM_ID = MainResultData.ITEM_ID;
              this.mainFormData.form1Data.ITEM_CODE = MainResultData.ITEM_CODE;
              this.mainFormData.form1Data.ITEM_DESC = MainResultData.ITEM_DESC;
              this.mainFormData.form1Data.BATCH_QTY = MainResultData.BATCH_QTY;
              this.mainFormData.form1Data.STOCK_CODE = MainResultData.STOCK_CODE;
              this.mainFormData.form1Data.ONETIME_PURCHASE_FLAG_TL = MainResultData.ONETIME_PURCHASE_FLAG_TL;
              this.mainFormData.form1Data.EXAMINED_STRINGENCY_TL = MainResultData.EXAMINED_STRINGENCY_TL;
              this.mainFormData.form1Data.EXAMINED_TYPE_TL = MainResultData.EXAMINED_TYPE_TL;
              this.mainFormData.form1Data.TYPE_TEST_FLAG_TL = MainResultData.TYPE_TEST_FLAG_TL;
              this.mainFormData.form1Data.SORT_FLAG_TL = MainResultData.SORT_FLAG_TL;
              this.mainFormData.form1Data.HS_FLAG_TL = MainResultData.HS_FLAG_TL;
              this.mainFormData.form1Data.INSPECTION_LEVEL = MainResultData.INSPECTION_LEVEL;
              this.mainFormData.form1Data.INSPECTION_LEVEL_TL = MainResultData.INSPECTION_LEVEL_TL;
              this.mainFormData.form1Data.EXAMINED_STRINGENCY = MainResultData.EXAMINED_STRINGENCY;
              this.mainFormData.form1Data.ONETIME_PURCHASE_FLAG = MainResultData.ONETIME_PURCHASE_FLAG;
              this.mainFormData.form1Data.TRIAL_FLAG = MainResultData.TRIAL_FLAG;
              this.mainFormData.form1Data.TRIAL_FLAG_TL = MainResultData.TRIAL_FLAG_TL;
              this.mainFormData.form1Data.SAMPLE_QTY = MainResultData.SAMPLE_QTY;
              this.mainFormData.form1Data.COMMON_STANDARDS_ID = MainResultData.COMMON_STANDARDS_ID;
              this.mainFormData.form1Data.COMMON_STANDARDS_NAME = MainResultData.COMMON_STANDARDS_NAME;
              this.mainFormData.form1Data.SPECIAL_STANDARDS_ID = MainResultData.SPECIAL_STANDARDS_ID;
              this.mainFormData.form1Data.SPECIAL_STANDARDS_NAME = MainResultData.SPECIAL_STANDARDS_NAME;
              this.mainFormData.form1Data.CHECKED_RESULT = MainResultData.CHECKED_RESULT;
              this.mainFormData.form1Data.CHECKER = MainResultData.CHECKER;
              this.mainFormData.form1Data.BRAND = MainResultData.BRAND;
              this.mainFormData.form1Data.BATCH_INFO = MainResultData.BATCH_INFO;
              this.mainFormData.form1Data.DEFECT_CLASS_TL = MainResultData.DEFECT_CLASS_TL;
              this.mainFormData.form1Data.LIABILITY_ATTRIBUTION_TL = MainResultData.LIABILITY_ATTRIBUTION_TL;
              this.mainFormData.form1Data.RESPONSIBILITY_INSIDE_TL = MainResultData.RESPONSIBILITY_INSIDE_TL;
              this.mainFormData.form1Data.CHECKED_RESULT_TL = MainResultData.CHECKED_RESULT_TL;
              this.mainFormData.form1Data.REMARK = MainResultData.REMARK;
  
              let DTLS = MainResultData.DTLS;
              let len3 = DTLS.length;
              this.mainFormData.form3Data = [];
              this.mainFormData.form4Data = [];
              let obj = null;
              let maxSampleMeteringCount = 0;
              let i3a = 0;
              let i3b = 0;
              for (var i3 = 0; i3 < len3; i3++) {
                obj = DTLS[i3];
                if (!this.isEmptyValue(obj.SAMPLE_METERING_COUNT) && maxSampleMeteringCount < obj.SAMPLE_METERING_COUNT) {
                  maxSampleMeteringCount = obj.SAMPLE_METERING_COUNT;
                }
                let standardsItemFileStr = obj.STANDARDS_ITEM_FILE;// 'name1.jpg:94642456,name2.jpg:94642456'
                let standardsItemFileArr = [];
                if (!this.isEmptyValue(standardsItemFileStr)) {
                    let arr1 = standardsItemFileStr.split(',');
                    let len1 = arr1.length;
                    if (len1 > 0) {
                        let arr1Split = null;
                        for (var arr1i = 0; arr1i < len1; arr1i++) {
                          arr1Split = arr1[arr1i].split(':');
                          standardsItemFileArr.push({
                            name: arr1Split[0],
                            fileId: arr1Split[1],
                            status: 'finished'
                          });
                        }
                    }
                }
                if (obj.ITEMS_PROPERTY === 'Metering') {
                  this.mainFormData.form3Data.push({
                    dtlsIndex: i3,
                    index: i3a,
                    ITEMS_CATEGORY: obj.ITEMS_CATEGORY,
                    ITEMS_CATEGORY_TL: obj.ITEMS_CATEGORY_TL,
                    STANDARDS_ITEM_ID: obj.STANDARDS_ITEM_ID,
                    ITEMS_NAME: obj.ITEMS_NAME,
                    TECHNICAL_REQUIREMENT: obj.TECHNICAL_REQUIREMENT,
                    ITEMS_PROPERTY_FLOOR: obj.ITEMS_PROPERTY_FLOOR,
                    ITEMS_PROPERTY_CEILING: obj.ITEMS_PROPERTY_CEILING,
                    ITEMS_PROPERTY_BENCHMARK: obj.ITEMS_PROPERTY_BENCHMARK,
                    ITEMS_PROPERTY_UOM: obj.ITEMS_PROPERTY_UOM,
                    ITEMS_LEVEL: obj.ITEMS_LEVEL,
                    EXAMINED_TOOL: obj.EXAMINED_TOOL,
                    INSPECTION_LEVEL: obj.INSPECTION_LEVEL,
                    INSPECTION_LEVEL_TL: obj.INSPECTION_LEVEL_TL,
                    SAMPLE_QTY: obj.SAMPLE_QTY,
                    NG_QTY: obj.NG_QTY,
                    SAMPLE_METERING_COUNT: obj.SAMPLE_METERING_COUNT,
                    SAMPLE_METERING_COUNT_OBJ: [],
                    EXAMINED_BASIS: obj.EXAMINED_BASIS,
                    STANDARDS_ITEM_FILE_ARR: standardsItemFileArr,
                    STANDARDS_ITEM_FILE: standardsItemFileStr,
                    NG_LEVEL: obj.NG_LEVEL,
                    CHECKED_RESULT: obj.CHECKED_RESULT,
                    NG_INFO: obj.NG_INFO,
                    REMARK: obj.REMARK
                  });
                  i3a++;
                } else {
                  this.mainFormData.form4Data.push({
                    dtlsIndex: i3,
                    index: i3b,
                    ITEMS_CATEGORY: obj.ITEMS_CATEGORY,
                    ITEMS_CATEGORY_TL: obj.ITEMS_CATEGORY_TL,
                    STANDARDS_ITEM_ID: obj.STANDARDS_ITEM_ID,
                    ITEMS_NAME: obj.ITEMS_NAME,
                    TECHNICAL_REQUIREMENT: obj.TECHNICAL_REQUIREMENT,
                    ITEMS_LEVEL: obj.ITEMS_LEVEL,
                    EXAMINED_TOOL: obj.EXAMINED_TOOL,
                    INSPECTION_LEVEL: obj.INSPECTION_LEVEL,
                    INSPECTION_LEVEL_TL: obj.INSPECTION_LEVEL_TL,
                    SAMPLE_QTY: obj.SAMPLE_QTY,
                    NG_QTY: obj.NG_QTY,
                    NG_INFO: obj.NG_INFO,
                    REMARK: obj.REMARK,
                    STANDARDS_ITEM_FILE_ARR: standardsItemFileArr,
                    STANDARDS_ITEM_FILE: standardsItemFileStr,
                    EXAMINED_BASIS: obj.EXAMINED_BASIS,
                    CHECKED_RESULT: obj.CHECKED_RESULT
                  });
                  i3b++;
                }
              }
  
              /* 检验批量小于(SAMPLE_METERING_COUNT计量项目输入测量值个数) -- start */
              if (!this.isEmptyValue(this.mainFormData.form1Data.BATCH_QTY) && parseInt(this.mainFormData.form1Data.BATCH_QTY) !== 0 && parseInt(this.mainFormData.form1Data.BATCH_QTY) < maxSampleMeteringCount) {
                maxSampleMeteringCount = parseInt(this.mainFormData.form1Data.BATCH_QTY);
              }
              /* 检验批量小于(SAMPLE_METERING_COUNT计量项目输入测量值个数) -- end */
              this.SAMPLE_METERING_COUNT_LIST = [];
              if (maxSampleMeteringCount > 0) {
                for (var count = 0; count < maxSampleMeteringCount; count++) {
                  this.SAMPLE_METERING_COUNT_LIST.push(count);
                }
                i3a = 0;
                for (i3 = 0; i3 < len3; i3++) {
                  obj = DTLS[i3];
                  let SampleMeteringCountOBJArr = [];
                  let checkedData = obj.CHECKED_DATA;
                  let checkedDataArr = [];
                  if (!this.isEmptyValue(checkedData)) {
                    checkedDataArr = checkedData.split(',');
                  }
                  for (count = 0; count < maxSampleMeteringCount; count++) {
                    if (!this.isEmptyValue(checkedData)) {
                      SampleMeteringCountOBJArr.push({
                        SAMPLE_METERING: checkedDataArr[count]
                      });
                    } else {
                      SampleMeteringCountOBJArr.push({
                        SAMPLE_METERING: ''
                      });
                    }
                  }
                  if (obj.ITEMS_PROPERTY === 'Metering') {
                    this.mainFormData.form3Data[i3a].SAMPLE_METERING_COUNT_OBJ = SampleMeteringCountOBJArr;
                    i3a++;
                  }
                }
              }
            }
          });
        },
        isEmptyValue(value) {
          if (value === null || value === 'null' || value === undefined || value === 'undefined' || value === '') {
            return true;
          }
          return false;
        },
        showTECHNICAL_REQUIREMENT(technicalRequirement) {
          this.htmlTECHNICAL_REQUIREMENT = technicalRequirement;
          this.modalTechnicalRequirement = true;
        },
        modalTechnicalRequirement_ok() {
  
        },
        modalTechnicalRequirement_cancel() {
  
        },
        form3TableRowClick(rowIndex) {
          this.mainFormData.form5Data.downloadList = this.mainFormData.form3Data[rowIndex].STANDARDS_ITEM_FILE_ARR;
        },
        form4TableRowClick(rowIndex) {
          this.mainFormData.form5Data.downloadList = this.mainFormData.form4Data[rowIndex].STANDARDS_ITEM_FILE_ARR;
        },
        downloadUploadListFile(fileId) {
          window.open(this.downloadUploadListFileUrl + fileId);
        },
        handleBodyScroll(event) {
          this.$refs.header.scrollLeft = event.target.scrollLeft;
        },
        handleMouseWheel(event) {
          const deltaX = event.deltaX;
          const $body = this.$refs.body;
          if (deltaX > 0) {
            $body.scrollLeft = $body.scrollLeft + 10;
          } else {
            $body.scrollLeft = $body.scrollLeft - 10;
          }
        },
        handleBodyScroll2(event) {
          this.$refs.header2.scrollLeft = event.target.scrollLeft;
        },
        handleMouseWheel2(event) {
          const deltaX = event.deltaX;
          const $body = this.$refs.body2;
          if (deltaX > 0) {
            $body.scrollLeft = $body.scrollLeft + 10;
          } else {
            $body.scrollLeft = $body.scrollLeft - 10;
          }
        },
        format (file) {
          const format = file.name.split('.').pop().toLocaleLowerCase() || '';
          let type = 'document';
          if (['gif', 'jpg', 'jpeg', 'png', 'bmp', 'webp'].indexOf(format) > -1) {
            type = 'image';
          }
          if (['mp4', 'm3u8', 'rmvb', 'avi', 'swf', '3gp', 'mkv', 'flv'].indexOf(format) > -1) {
            type = 'ios-film';
          }
          if (['mp3', 'wav', 'wma', 'ogg', 'aac', 'flac'].indexOf(format) > -1) {
            type = 'ios-musical-notes';
          }
          if (['doc', 'txt', 'docx', 'pages', 'epub', 'pdf'].indexOf(format) > -1) {
            type = 'document-text';
          }
          if (['numbers', 'csv', 'xls', 'xlsx'].indexOf(format) > -1) {
            type = 'stats-bars';
          }
          if (['keynote', 'ppt', 'pptx'].indexOf(format) > -1) {
            type = 'ios-videocam';
          }
          return type;
        }
      }
    };
  </script>
  